import { UserDataInterface } from 'interface/reducers/auth';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

interface IUseCheckUserRolesProps {
  userData: UserDataInterface;
}

export const useCheckUserRoles = (props: IUseCheckUserRolesProps) => {
  const { userData } = props;
  const history = useHistory();
  const [isUnverified, setIsUnverified] = useState(false);
  const hasSuspendedSeller = userData.roles?.includes('suspended_seller');
  const isSuspended = hasSuspendedSeller;

  useEffect(() => {
    if (!userData.isFetch && userData.roles.includes('unverified_user')) {
      setIsUnverified(true);
      return;
    }

    if (
      !userData.isFetch &&
      userData.roles &&
      userData.roles.indexOf('user') !== -1 &&
      userData.roles.indexOf('seller') === -1
    ) {
      history.push('/seller-registration');
      return;
    }

    if (userData.country_code && userData.country_code !== 'IDN') {
      history.replace('/user_dashboard/profile-settings');
      return;
    }
  }, [userData]);

  useEffect(() => {
    if (
      !userData.isFetch &&
      userData.roles &&
      userData.roles.indexOf('user') !== -1 &&
      userData.roles.indexOf('seller') === -1
    ) {
      history.push('/seller-registration');
    }
  }, []);

  return {
    isUnverified,
    isSuspended,
  };
};
